import Choices from 'choices.js/assets/scripts/dist/choices.min.js';
import {initInboxRetrieve, resumeInboxRetrieve} from './inbox_retrieve';
import {loadReplyBodies} from './inbox_reply_body';
import {initInboxStateMenu} from './inbox_state_menu';
import {detachRow, lowerPagerSummary, refreshSubtitle, shiftManagedScopeCount, shiftStateCount} from './inbox_list_counts';

const FILTER_SELECTORS = [
  '.email-responses-form #status',
  '.email-responses-form #language',
  '.email-responses-form #company_id',
  '.email-responses-form #credit_batch_id',
];

const FILTER_CHOICES_OPTIONS = {
  shouldSort: false,
  removeItems: true,
  removeItemButton: true,
  resetScrollPosition: false,
  placeholder: true,
};

export function initEmailResponsesFilters() {
  FILTER_SELECTORS.forEach((selector) => {
    if ($(selector).length > 0) {
      new Choices(selector, FILTER_CHOICES_OPTIONS);
    }
  });
}

function fetchFilteredResults(changedField?: string) {
  const $form = $(".email-responses-form");
  const action = $form.attr("action");
  const queryString = $form.serialize();
  let data = queryString;
  if (changedField) {
    data += "&changed_field=" + encodeURIComponent(changedField);
  }

  if (history.replaceState) {
    history.replaceState(null, '', action + (queryString ? "?" + queryString : ""));
  }

  const $results = $(".email-responses-results");
  $.ajax({
    url: action,
    method: "GET",
    data: data,
    dataType: "script",
    beforeSend: () => {
      $(".filters-wrapper").addClass("d-none");
      $results.html('<div class="results-loading"><div class="spinner-border text-primary" role="status"></div></div>');
    },
  });
}

function emailChainStatus(email_chain_id: string) {
  var elem = $(".email-chain#" + email_chain_id);

  var statuses = elem.children(".email-response").map(function() {
    return $(this).data("manual-status");
  }).get()

  if (statuses.includes("interested")) {
    return "interested";
  } else if (statuses.includes("response")) {
    return "response";
  } else {
    return "pending";
  }
}

export function initEmailResponses() {
  const $emailResponses = $(".email-responses");

  if ($emailResponses.hasClass("inbox-page")) {
    initInbox();
    return;
  }

  $emailResponses.off("click.setStatus").on(
    "click.setStatus",
    ".email-response a.set-status",
    function(event) {
      var elem = $(this);
      var url = elem.attr("href");
      event.preventDefault();

      $.post((url as string), function(data) {
        var email_response_id = data["email_response_id"];
        var email_chain_id = data["email_chain_id"];
        var email_chain_elem = $(".email-chain#" + email_chain_id);
        var email_response_elem = $(".email-response#" + email_response_id);
        var email_chain_status_before = emailChainStatus(email_chain_id);
        var to_status = data["to"];

        email_response_elem.data("manual-status", to_status);
        email_response_elem.find(".fancy-button").removeClass("active");
        email_response_elem.find(".fancy-button." + to_status).addClass("active");

        var email_chain_status_after = emailChainStatus(email_chain_id);

        if (email_chain_status_before != email_chain_status_after) {
          var from_count_elem = $("#status-count-" + email_chain_status_before);
          var from_count = parseInt(from_count_elem.text(), 10);
          var to_count_elem = $("#status-count-" + email_chain_status_after);
          var to_count = parseInt(to_count_elem.text(), 10);

          from_count_elem.text(from_count - 1);
          to_count_elem.text(to_count + 1);
        }

        var statuses = email_chain_elem.children(".email-response").map(function() {
          return $(this).data("manual-status");
        }).get();

        if (!statuses.includes("") || statuses.includes("interested")) {
          email_chain_elem.remove();
        }

        if ($(".email-chain").length === 0) {
          fetchFilteredResults();
        }
      });
    }
  );

  $(".email-responses-form").off("change.filter").on("change.filter", function(event) {
    const changedField = (event.target as HTMLElement).id;

    if (!$(".email-responses-results").length) {
      (this as HTMLFormElement).submit();
      return;
    }

    if (changedField === "company_id") {
      if ($(".email-responses-form #credit_batch_id").length) {
        $(".email-responses-form #credit_batch_id").val("all");
      }
    }

    fetchFilteredResults(changedField);
  });

  $emailResponses.off("click.setPendingAll").on(
    "click.setPendingAll",
    "a.set-pending-as-response",
    function(event) {
      event.preventDefault();

      const url = $(this).attr("href")
      const status_updates = {}

      $(".email-chain").each(function() {
        $(this).children(".email-response").each(function() {
          if ($(this).data("manual-status") === "") {
            status_updates[$(this).attr("id")] = "response"
          }
        })
      })

      $.post((url as string), {statuses: status_updates}, function() {
        fetchFilteredResults();
      })
    }
  );

  $emailResponses.off("click.setPendingChain").on(
    "click.setPendingChain",
    "a.set-pending-for-email-chain-as-response",
    function(event) {
      event.preventDefault();

      const $trigger = $(this);
      const url = $trigger.attr("href");
      const status_updates = {};
      const email_chain_elem = $trigger.parent(".email-chain");

      email_chain_elem.children(".email-response").each(function() {
        if ($(this).data("manual-status") === "") {
          status_updates[$(this).attr("id")] = "response"
        }
      });

      $.post((url as string), {statuses: status_updates}, function() {
        email_chain_elem.remove();

        if ($(".email-chain").length === 0) {
          fetchFilteredResults();
        }
      })
    }
  );

  $("#search-input").off("keypress.search").on("keypress.search", function(event) {
    if (event.key === "Enter") {
      $("#query").val($(this).val() as string);
      fetchFilteredResults();
    }
  });

  $(".filters-wrapper").removeClass("d-none");
}

const CONTACTED_STATUS_PILLS: Record<string, [string, string]> = {
  interested: ["reachable", "Interested"],
  not_right_now: ["not-right-now", "Not right now"],
  response: ["contacted", "Responded"],
  interview: ["interview", "Interview"],
  hired: ["hired", "Hired"],
};

const ANOE_STATUS_TAGS: Record<string, string> = {
  interested: '<span class="label positive-response-label">Interested</span>',
  not_right_now: '<span class="label not-right-now" style="background-color: #999">Not right now</span>',
  response: '<span class="label" style="background-color: #00C7BE">Responded</span>',
  interview: '<span class="label" style="background-color: #f6d061">Interview</span>',
  hired: '<span class="label" style="background-color: #1DBF73">Hired</span>',
};

function reflectRowStatus(elem: JQuery, to: string): void {
  const $tr = elem.closest("tr");
  if (!$tr.length) return;

  if ($tr.hasClass("reply-row")) {
    const parentRow = document.getElementById($tr.attr("data-parent") || "");
    if (!parentRow) return;
    parentRow.setAttribute("data-status", to === "response" ? "responded" : to);
    const pill = CONTACTED_STATUS_PILLS[to];
    const pillEl = parentRow.querySelector(".pill");
    if (pill && pillEl) {
      pillEl.className = "pill " + pill[0];
      pillEl.innerHTML = '<span class="pdot"></span>' + pill[1];
    }
  } else if ($tr.attr("data-status") !== undefined) {
    // accepted-no-email: chips sit in the candidate row itself
    $tr.attr("data-status", to);
    const html = ANOE_STATUS_TAGS[to];
    if (html) {
      const nameLink = $tr.find(".cand-name-link").first();
      const existing = nameLink.find(".label");
      if (existing.length) existing.replaceWith(html);
      else nameLink.append(" " + html);
    }
  }
}

let focusedChainId: string | null = null;

// Managed-scope filter lists page and search from the server (EmailResponsesController#filter_options).
const REMOTE_DD_SCROLL_PX = 40;
const REMOTE_DD_SEARCH_DELAY_MS = 250;

type RemoteDdState = { page: number; query: string; hasMore: boolean; loading: boolean; seq: number; timer?: number };
const remoteDdStates = new WeakMap<HTMLElement, RemoteDdState>();
const remoteDdScrollBound = new WeakSet<HTMLElement>();

function remoteDdState(dd: HTMLElement): RemoteDdState {
  let state = remoteDdStates.get(dd);
  if (!state) {
    state = { page: 1, query: "", hasMore: dd.getAttribute("data-has-more") === "true", loading: false, seq: 0 };
    remoteDdStates.set(dd, state);
  }
  return state;
}

function remoteDdOption($dd: JQuery, label: string, value: string): JQuery {
  const multiple = $dd.hasClass("multi");
  const $input = $("<input>", { type: multiple ? "checkbox" : "radio", name: $dd.attr("data-name"), value });
  return $("<label>", { class: "inbox-dd-opt", title: label }).append(
    $input,
    $('<span class="inbox-dd-box"><span class="inbox-dd-tick"></span></span>'),
    $("<span>", { class: "inbox-dd-opt-label", text: label })
  );
}

// `reset` starts over from the first chunk for the current query, keeping the ticked rows so a
// search never drops a live selection; otherwise the next chunk is appended.
function loadRemoteDd($dd: JQuery, reset: boolean) {
  const dd = $dd[0];
  const state = remoteDdState(dd);
  if (!reset && (state.loading || !state.hasMore)) return;

  const page = reset ? 1 : state.page + 1;
  const seq = ++state.seq;
  state.loading = true;

  $.getJSON(String($dd.attr("data-remote-url")), { query: state.query, page })
    .done((response: { options: [string, string][]; has_more: boolean }) => {
      if (seq !== state.seq) return; // a newer search superseded this one

      const $list = $dd.find(".inbox-dd-options");
      if (reset) $list.find(".inbox-dd-opt").filter((_i, el) => !$(el).find("input").is(":checked")).remove();

      const rendered = new Set($list.find("input").map((_i, el) => String($(el).val())).get());
      response.options.forEach(([label, value]) => {
        if (!rendered.has(String(value))) $list.append(remoteDdOption($dd, label, String(value)));
      });

      state.page = page;
      state.hasMore = response.has_more;
      $dd.find(".inbox-dd-empty").toggleClass("d-none", $list.find(".inbox-dd-opt").length > 0);
    })
    .always(() => {
      if (seq === state.seq) state.loading = false;
    });
}

function bindRemoteDdScroll($dd: JQuery) {
  const menu = $dd.find(".inbox-dd-menu")[0];
  if (!menu || remoteDdScrollBound.has(menu)) return;
  remoteDdScrollBound.add(menu);

  menu.addEventListener("scroll", () => {
    if (menu.scrollTop + menu.clientHeight >= menu.scrollHeight - REMOTE_DD_SCROLL_PX) loadRemoteDd($dd, false);
  });
}

function initInbox() {
  const $page = $(".inbox-page");
  const $drawer = $page.find(".inbox-drawer");
  const $backdrop = $page.find(".inbox-drawer-backdrop");
  const $bulkToast = $page.find(".inbox-bulk-toast");
  initInboxRetrieve($page, refreshThread);
  const $bulkBar = $page.find(".inbox-bulk-bar");
  const csrfToken = () => $("meta[name='csrf-token']").attr("content");

  const submitFilters = () => ($page.find(".inbox-filter-form") as any).trigger("submit");

  // Ticking several boxes in a multiselect should not cost a round trip each; the pending
  // selection is applied when the menu closes.
  let pendingFilterChange = false;

  function optionLabel($option: JQuery) {
    return $option.find(".inbox-dd-opt-label, .inbox-sentiment").first().text().trim();
  }

  function refreshTrigger($dd: JQuery) {
    // The single-select menus carry an "all" radio; it means "no filter", not a selection.
    const $checked = $dd.find(".inbox-dd-menu input:checked").not('[value="all"]');
    const allLabel = String($dd.data("all-label") || "All");
    const label = $checked.length === 0
      ? allLabel
      : ($checked.length === 1 ? optionLabel($checked.closest(".inbox-dd-opt")) : `${$checked.length} selected`);

    $dd.find(".inbox-dd-label").text(label);
    $dd.find(".inbox-dd-trigger").toggleClass("has-val", $checked.length > 0);
    $dd.find(".inbox-dd-all").toggleClass("active", $checked.length === 0);
  }

  function widenCompanyForFlag($input: JQuery) {
    if ($input.attr("name") !== "flag" || !$input.is(":checked") || String($input.val()) === "all") return;

    const $company = $page.find('.inbox-dd-menu input[name="company_id"]');
    const $companyDd = $company.closest(".inbox-dd");
    // Non-admins are pinned to their own company server-side; widening would only mislabel it.
    if (!$company.length || $companyDd.data("pinned") === true) return;

    // A company the user picked on purpose stays; only the "My company" default is widened.
    const $selected = $company.filter(":checked");
    if ($selected.length && String($selected.val()) !== "current_user") return;

    $company.prop("checked", false);
    $company.filter('[value="all"]').prop("checked", true);
    refreshTrigger($companyDd);

    // Credit batches are company-scoped, so a batch picked for the old company no longer applies.
    const $creditBatches = $page.find('.inbox-dd-menu input[name="credit_batch_id[]"]');
    if ($creditBatches.filter(":checked").length) {
      $creditBatches.prop("checked", false);
      refreshTrigger($creditBatches.closest(".inbox-dd"));
    }
  }

  function closeDropdowns() {
    $page.find(".inbox-dd.open").removeClass("open").find(".inbox-dd-trigger").attr("aria-expanded", "false");

    if (pendingFilterChange) {
      pendingFilterChange = false;
      submitFilters();
    }
  }

  // Each menu carries a search box; the "All …" rows stay put while option rows filter.
  // A remote list is searched server-side, debounced, instead of filtered in place.
  function applyDdSearch($input: JQuery) {
    const $dd = $input.closest(".inbox-dd");
    if ($dd.is("[data-remote-url]")) {
      const state = remoteDdState($dd[0]);
      const query = String($input.val() || "").trim();
      window.clearTimeout(state.timer);
      if (query === state.query) return;

      state.query = query;
      state.timer = window.setTimeout(() => loadRemoteDd($dd, true), REMOTE_DD_SEARCH_DELAY_MS);
      return;
    }

    const query = String($input.val() || "").trim().toLowerCase();
    const $menu = $input.closest(".inbox-dd-menu");
    let matches = 0;

    $menu.find(".inbox-dd-opt").each(function() {
      const $opt = $(this);
      if ($opt.hasClass("inbox-dd-all") || $opt.find("input").val() === "all") return;

      const hit = !query || optionLabel($opt).toLowerCase().indexOf(query) !== -1;
      $opt.toggleClass("d-none", !hit);
      if (hit) matches += 1;
    });

    $menu.find(".inbox-dd-empty").toggleClass("d-none", matches > 0);
  }

  function resetDdSearch($dd: JQuery) {
    const $search = $dd.find(".inbox-dd-search input");
    if (!$search.length) return;

    $search.val("");
    applyDdSearch($search);
    $search.trigger("focus");
  }

  const $composeEditor = () => $drawer.find(".inbox-reply-body");
  const composeText = () => String($composeEditor().val() || "");

  function composeBody() {
    const text = composeText();
    if (!text.trim()) return "";

    return text
      .split(/\n{2,}/)
      .map((paragraph) => `<p>${$("<div>").text(paragraph).html().replace(/\n/g, "<br>")}</p>`)
      .join("");
  }

  // A draft card's contenteditable keeps its markup even when emptied, so test the text, not the tags.
  const isBlankHtml = (html: string) => $("<div>").html(html).text().trim() === "";

  const SPARKLE_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">' +
    '<path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z"/></svg>';

  function closeDrawer() {
    $drawer.removeClass("open").attr("aria-hidden", "true").empty();
    $backdrop.removeClass("open").attr("aria-hidden", "true");
  }

  function post(url: string, data: any, success: (response: any) => void, complete?: () => void) {
    $.ajax({
      url,
      method: "POST",
      data,
      headers: {"X-CSRF-Token": csrfToken()},
      success,
      error: (xhr) => alert((xhr.responseJSON && xhr.responseJSON.error) || "Something went wrong. Please try again."),
      complete
    });
  }

  // The provider call takes seconds and the server has no idempotency key, so a second click while the
  // first request is in flight sends the email twice. Stay disabled on success: the page reloads.
  function sendReply($button: JQuery<HTMLElement>, subject: string, body: string) {
    if ($button.prop("disabled")) return;

    const chainId = $drawer.find(".inbox-drawer-body").data("chain-id");
    if (!subject.trim() || isBlankHtml(body)) return alert("A subject and reply are required.");

    let sent = false;
    $button.prop("disabled", true);
    post(`/email_chains/${chainId}/send_inbox_reply`, {reply: {subject, body}}, () => {
      sent = true;
      window.location.reload();
    }, () => { if (!sent) $button.prop("disabled", false); });
  }

  $(document).off("click.inboxTab").on("click.inboxTab", ".inbox-tab", function() {
    $page.find("input[name='response_state']").val($(this).data("response-state"));
    ($page.find(".inbox-filter-form") as any).trigger("submit");
  });

  $(document).off("click.inboxScope").on("click.inboxScope", ".inbox-scope-seg button", function() {
    const $button = $(this);
    if ($button.hasClass("active")) return;

    $page.find("input[name='scope']").val(String($button.data("scope")));
    ($page.find(".inbox-filter-form") as any).trigger("submit");
  });

  $page.off("click.inboxDd").on("click.inboxDd", ".inbox-dd-trigger", function(event) {
    event.stopPropagation();
    const $dd = $(this).closest(".inbox-dd");
    const wasOpen = $dd.hasClass("open");

    closeDropdowns();
    if (!wasOpen) {
      $dd.addClass("open").find(".inbox-dd-trigger").attr("aria-expanded", "true");
      resetDdSearch($dd);
      if ($dd.is("[data-remote-url]")) bindRemoteDdScroll($dd);
    }
  });

  // Keep a multiselect menu open while the user ticks boxes.
  $page.off("click.inboxDdMenu").on("click.inboxDdMenu", ".inbox-dd.multi .inbox-dd-menu", (event) => event.stopPropagation());

  $page.off("input.inboxDdSearch").on("input.inboxDdSearch", ".inbox-dd-search input", function() {
    applyDdSearch($(this));
  });

  // Enter in the search box would otherwise implicitly submit the surrounding filter form.
  $page.off("keydown.inboxDdSearch").on("keydown.inboxDdSearch", ".inbox-dd-search input", function(event) {
    if (event.key === "Enter") event.preventDefault();
  });

  $page.off("click.inboxDdAll").on("click.inboxDdAll", ".inbox-dd-all", function() {
    const $dd = $(this).closest(".inbox-dd");
    if ($dd.find(".inbox-dd-menu input:checked").length === 0) return;

    $dd.find(".inbox-dd-menu input").prop("checked", false);
    refreshTrigger($dd);
    pendingFilterChange = false;
    submitFilters();
  });

  $page.off("change.inboxFilter").on("change.inboxFilter", '.inbox-dd-menu input[type="checkbox"], .inbox-dd-menu input[type="radio"]', function() {
    const $dd = $(this).closest(".inbox-dd");
    refreshTrigger($dd);
    widenCompanyForFlag($(this));

    if ($dd.hasClass("multi")) {
      pendingFilterChange = true;
    } else {
      submitFilters();
    }
  });

  $(document).off("click.inboxDdClose").on("click.inboxDdClose", function(event) {
    if ($(event.target).closest(".inbox-dd").length) return;
    closeDropdowns();
  });

  const rowControl = "button,input,label,a[href],[data-candidate-open]";

  function showThread(html: string) {
    $drawer.html(html).addClass("open").attr("aria-hidden", "false");
    $backdrop.addClass("open").attr("aria-hidden", "false");
    updateManualActions();
    resumeInboxRetrieve($page);
    loadReplyBodies($drawer);
  }

  // Re-renders the open thread from the latest emails and replies, e.g. once an inbox check has
  // pulled new ones in. What the user typed and the editor's collapsed state survive the swap.
  function refreshThread(url: string) {
    const draft = composeText();
    const editorHidden = $drawer.find(".inbox-drawer-footer").hasClass("editor-hidden");

    $.get(url, (html) => {
      // The user closed the drawer or opened another thread while this was loading.
      if (!$drawer.hasClass("open") || $drawer.find(".inbox-retrieve").data("thread-url") !== url) return;

      showThread(html);
      if (draft) $composeEditor().val(draft).trigger("input");
      reflectEditorToggle(editorHidden);
    });
  }

  $page.off("click.inboxRow").on("click.inboxRow", ".inbox-row", function(event) {
    if ($(event.target).closest(rowControl).length) return;
    $.get($(this).data("thread-url"), showThread);
  });

  $page.off("keydown.inboxRow").on("keydown.inboxRow", ".inbox-row", function(event) {
    if ($(event.target).closest(rowControl).length) return;
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      $(this).trigger("click");
    }
  });

  // Covers the drawer's flag too: the drawer sits inside the page.
  initInboxStateMenu($page, post);

  // A scheduled follow-up is never sent for the user, so this is the only way it goes out.
  $page.off("click.inboxScheduleSend").on("click.inboxScheduleSend", ".inbox-schedule-send", function(event) {
    event.stopPropagation();
    if (!window.confirm("Send this follow-up now?")) return;

    const $button = $(this).prop("disabled", true);
    post(String($button.data("url")), {}, () => window.location.reload(), () => $button.prop("disabled", false));
  });

  $page.off("click.inboxScheduleRemove").on("click.inboxScheduleRemove", ".inbox-schedule-remove", function(event) {
    event.stopPropagation();
    if (!window.confirm("Remove this scheduled follow-up? The drafted follow-up email will be discarded.")) return;

    const $button = $(this).prop("disabled", true);
    post(String($button.data("url")), {}, () => window.location.reload(), () => $button.prop("disabled", false));
  });

  function focusLinkedChain() {
    const chainId = String($page.data("focus-chain-id") || "");
    if (!chainId) {
      focusedChainId = null;
      return;
    }

    const $row = $page.find(`.inbox-response-list .inbox-row[data-chain-id="${chainId}"]`);
    if (!$row.length) return;

    ($row.get(0) as HTMLElement).scrollIntoView({behavior: "smooth", block: "center"});
    if (focusedChainId === chainId) return;

    focusedChainId = chainId;
    $row.addClass("inbox-row--focused");
    $row.trigger("click");

    window.setTimeout(() => $row.removeClass("inbox-row--focused"), 2500);
  }

  focusLinkedChain();

  // Rows for conversations without a reply carry no response id and nothing to classify, so a
  // blank one never reaches the bulk endpoint.
  const selectedResponseIds = () => $page.find(".inbox-row-select input:checked").map(function() {
    return String($(this).closest(".inbox-row").data("response-id") || "");
  }).get().filter((id) => id !== "");

  function refreshBulkBar() {
    const count = selectedResponseIds().length;
    $bulkBar.prop("hidden", count === 0).find(".inbox-bulk-count").text(`${count} selected`);
    if (count === 0) closeBulkMenus();

    const total = $page.find(".inbox-row .inbox-row-select input").length;
    $page.find(".inbox-select-all input").prop({
      checked: total > 0 && count === total,
      indeterminate: count > 0 && count < total,
      disabled: total === 0
    });
  }

  $page.off("change.inboxBulkSelect").on("change.inboxBulkSelect", ".inbox-row .inbox-row-select input", refreshBulkBar);

  $page.off("change.inboxSelectAll").on("change.inboxSelectAll", ".inbox-select-all input", function() {
    $page.find(".inbox-row .inbox-row-select input").prop("checked", $(this).prop("checked"));
    refreshBulkBar();
  });

  function closeBulkMenus() {
    const open = $bulkBar.find(".inbox-bulk-pop:not([hidden])").length > 0;
    $bulkBar.find(".inbox-bulk-pop").prop("hidden", true);
    $bulkBar.find(".inbox-bulk-trigger").attr("aria-expanded", "false");
    return open;
  }

  function clearBulkSelection() {
    $page.find(".inbox-row-select input:checked").prop("checked", false);
    refreshBulkBar();
  }

  $page.off("click.inboxBulkClear").on("click.inboxBulkClear", ".inbox-bulk-clear", clearBulkSelection);

  $page.off("click.inboxBulkMenu").on("click.inboxBulkMenu", ".inbox-bulk-trigger", function(event) {
    event.stopPropagation();
    const $pop = $(this).siblings(".inbox-bulk-pop");
    const opening = $pop.prop("hidden");
    closeBulkMenus();
    $pop.prop("hidden", !opening);
    $(this).attr("aria-expanded", String(opening));
  });

  $(document).off("click.inboxBulkMenuOutside").on("click.inboxBulkMenuOutside", (event) => {
    if (!$(event.target).closest(".inbox-bulk-menu").length) closeBulkMenus();
  });

  $page.off("click.inboxBulkChoice").on("click.inboxBulkChoice", ".inbox-bulk-bar .inbox-sentiment-choice", function() {
    const ids = selectedResponseIds();
    if (ids.length === 0) return;

    const $button = $(this).prop("disabled", true);
    const statuses: {[id: string]: string} = {};
    ids.forEach((id) => { statuses[id] = String($button.data("status")); });

    post(String($bulkBar.data("url")), {statuses}, (response) => {
      const updated = Number(response.updated || 0);
      $bulkToast.text(`${updated} repl${updated === 1 ? "y" : "ies"} classified.`).addClass("visible");
      window.setTimeout(() => window.location.reload(), 800);
    }, () => $button.prop("disabled", false));
  });

  $page.off("click.inboxBulkState").on("click.inboxBulkState", ".inbox-bulk-bar .inbox-bulk-state", function() {
    const ids = $page.find(".inbox-row-select input:checked").map(function() {
      return String($(this).closest(".inbox-row").data("chain-id") || "");
    }).get().filter((id) => id !== "");
    if (ids.length === 0) return;

    const $button = $(this).prop("disabled", true);
    const label = String($button.data("label"));

    const state = String($button.data("state"));

    post(String($bulkBar.data("state-url")), {email_chain_ids: ids, state}, (response) => {
      const updated = Number(response.updated || 0);
      $bulkToast.text(`${updated} conversation${updated === 1 ? "" : "s"} moved to ${label}.`).addClass("visible");
      window.setTimeout(() => $bulkToast.removeClass("visible"), 2500);
      removeMovedRows((response.email_chain_ids || []).map(String), state);
      refreshBulkBar();
    }, () => $button.prop("disabled", false));
  });

  // Every tab lists one state, so a row moved to another state leaves the list.
  function removeMovedRows(chainIds: string[], state: string) {
    const managedScope = $page.find(".inbox-filter-form input[name='scope']").val() === "managed";
    const $list = $page.find(".inbox-response-list");
    let removed = 0;

    chainIds.forEach((id) => {
      const $row = $list.find(`.inbox-row[data-chain-id="${id}"]`);
      const previous = String($row.data("response-state") || "");
      if (!$row.length || previous === state) return;

      shiftStateCount(previous, -1);
      shiftStateCount(state, 1);
      if (managedScope) shiftManagedScopeCount((state === "needs_reply" ? 1 : 0) - (previous === "needs_reply" ? 1 : 0));
      detachRow($row.get(0) as HTMLElement);
      removed += 1;
    });

    refreshSubtitle();
    if (removed === 0) return;
    if ($list.find(".inbox-row").length === 0) return window.location.reload();

    lowerPagerSummary($list.get(0) as Element, removed);
  }

  $page.off("click.inboxClose").on("click.inboxClose", ".inbox-drawer-close, .inbox-drawer-backdrop", closeDrawer);

  // The drawer is injected html, so the arrow is wired by delegation like every other control in
  // it; the dialog itself is a page-level Stimulus controller, reached through a window event --
  // the same bridge the AI draft modal uses.
  $page.off("click.inboxForward").on("click.inboxForward", ".inbox-forward-open", function() {
    const $button = $(this);
    let addresses: string[] = [];
    try {
      addresses = JSON.parse(String($button.attr("data-addresses") || "[]"));
    } catch (e) {
      addresses = [];
    }

    window.dispatchEvent(new CustomEvent("forward:open", {detail: {
      chainId: String($drawer.find(".inbox-drawer-body").data("chain-id") || ""),
      url: String($button.data("url") || ""),
      candidate: String($button.data("candidate") || ""),
      campaign: String($button.data("campaign") || ""),
      messageCount: String($button.data("message-count") || ""),
      addresses,
      canRemember: String($button.data("can-remember")) === "true"
    }}));
  });
  $(document).off("keydown.inbox").on("keydown.inbox", (event) => {
    if (event.key !== "Escape") return;
    if (managerOpen()) return;
    // Escape belongs to whatever is on top. Without this the forward dialog closes AND the
    // drawer underneath is emptied, so the user loses the thread they were forwarding -- and
    // mid-send the dialog refuses to close, leaving it over a drawer that is already gone.
    if (forwardModalOpen()) return;
    if (closeTemplatePopover()) return;
    if (closeBulkMenus()) return;
    if (!$drawer.hasClass("open") && !$bulkBar.prop("hidden")) return clearBulkSelection();
    closeDropdowns();
    closeDrawer();
  });

  function applySentiment(chainId: string, responseId: string, status: string, label: string) {
    const $row = $page.find(`.inbox-response-list .inbox-row[data-chain-id="${chainId}"]`);
    // Setting a sentiment records a reviewer, so the reply counts as triaged from now on.
    $row.removeClass("unread");
    $row.find(".inbox-sentiment").attr("class", `inbox-sentiment ${status}`).text(label);

    $drawer.find(`.inbox-message-card[data-response-id="${responseId}"] .inbox-sentiment`)
      .attr("class", `inbox-sentiment ${status}`)
      .find(".inbox-sentiment-value").text(label);
  }

  $drawer.off("click.inboxSentiment").on("click.inboxSentiment", ".inbox-sentiment-picker button", function() {
    const $button = $(this);
    post($button.data("url"), {}, (result) => {
      $button.addClass("active").siblings().removeClass("active");
      applySentiment(
        String(result.email_chain_id),
        String(result.email_response_id),
        String($button.data("status")),
        $button.text().trim()
      );
      updateManualActions();
    });
  });

  function resetManualSchedule() {
    $drawer.find(".inbox-manual-when").addClass("d-none");
    $drawer.find(".inbox-manual-schedule").removeClass("confirming").text("Schedule");
  }

  function updateManualActions() {
    const canDiscard = composeText().trim() !== "";
    const canSchedule = String($drawer.find(".inbox-sentiment-picker .active").data("status") || "") === "not_right_now";

    $drawer.find(".inbox-manual-discard").toggleClass("d-none", !canDiscard);
    $drawer.find(".inbox-manual-schedule").toggleClass("d-none", !canSchedule);
    if (!canSchedule) resetManualSchedule();
  }

  $drawer.off("click.inboxManualDiscard").on("click.inboxManualDiscard", ".inbox-manual-discard", function() {
    $composeEditor().val("").trigger("focus");
    // The box is no longer the AI's words, so the violet border and pill come off with it.
    setAiDraft(false);
    updateManualActions();
  });

  $drawer.off("click.inboxManualSchedule").on("click.inboxManualSchedule", ".inbox-manual-schedule", function() {
    const $button = $(this);
    const $when = $drawer.find(".inbox-manual-when");
    const $date = $when.find(".inbox-manual-date");

    if (!$button.hasClass("confirming")) {
      // Mirror the AI draft's default: the follow-up lands 30 days out unless changed.
      const iso = (date: Date) => date.toISOString().slice(0, 10);
      const later = new Date();
      later.setDate(later.getDate() + 30);
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);

      if (!$date.val()) $date.val(iso(later));
      $date.attr("min", iso(tomorrow));
      $when.removeClass("d-none");
      $button.addClass("confirming").text("Confirm");
      return;
    }

    const subject = String($drawer.find(".inbox-drawer-footer").data("subject") || "");
    const body = composeBody();
    if (!subject.trim() || isBlankHtml(body)) return alert("A subject and reply are required.");
    const scheduledAt = String($date.val() || "");
    if (!scheduledAt) return alert("Choose a follow-up date.");

    const chainId = $drawer.find(".inbox-drawer-body").data("chain-id");
    $button.prop("disabled", true);
    post(
      `/email_chains/${chainId}/schedule_inbox_follow_up`,
      {follow_up: {scheduled_at: scheduledAt, subject, body}},
      () => window.location.reload(),
      () => $button.prop("disabled", false)
    );
  });

  $drawer.off("input.inboxManualBody").on("input.inboxManualBody", ".inbox-reply-body", updateManualActions);

  // The composer takes the bottom third of the drawer; collapsing it gives a long thread room to
  // read. Purely visual — the editor keeps whatever was typed, it is just not on screen.
  function reflectEditorToggle(hidden: boolean) {
    $drawer.find(".inbox-drawer-footer").toggleClass("editor-hidden", hidden);
    $drawer.find(".inbox-editor-toggle").attr("aria-expanded", String(!hidden))
      .find(".inbox-editor-toggle-label").text(hidden ? "Show editor" : "Hide editor");
  }

  const showComposeEditor = () => reflectEditorToggle(false);

  $drawer.off("click.inboxEditorToggle").on("click.inboxEditorToggle", ".inbox-editor-toggle", function() {
    reflectEditorToggle(!$drawer.find(".inbox-drawer-footer").hasClass("editor-hidden"));
  });

  $drawer.off("click.inboxComposeSend").on("click.inboxComposeSend", ".inbox-send-reply", function() {
    sendReply($(this), String($drawer.find(".inbox-drawer-footer").data("subject") || ""), composeBody());
  });

  $drawer.off("click.inboxEditorToggle").on("click.inboxEditorToggle", ".inbox-editor-toggle", function() {
    const hidden = $drawer.find(".inbox-drawer-footer").toggleClass("editor-hidden").hasClass("editor-hidden");

    // Only the label span, never the button: .text() on the button would eat its inline SVG.
    $(this).attr("aria-expanded", hidden ? "false" : "true")
      .find(".inbox-editor-toggle-label").text(hidden ? "Show editor" : "Hide editor");

    if (!hidden) $composeEditor().trigger("focus");
  });

  // ---- reply templates: the composer picker ----
  //
  // Filtering is server-side, so the chips and the search box issue the same request with different
  // params — one code path, and search reaches bodies, which a client-side filter over the truncated
  // preview could not. State is read back out of the DOM rather than kept in closures: the drawer is
  // replaced wholesale on every thread open, so a remembered category would go stale.
  const $tpl = () => $drawer.find(".inbox-tpl");
  const $tplPop = () => $tpl().find(".inbox-tpl-pop");
  const tplPopOpen = () => $tplPop().hasClass("open");
  const tplCategory = () => String($tpl().find(".inbox-tpl-chip.on").data("category") || "");
  const tplQuery = () => String($tpl().find(".inbox-tpl-search input").val() || "");
  const managerOpen = () => $("#reply-templates-modal").hasClass("open");
  const forwardModalOpen = () => $("#fwdmodal").hasClass("open");
  let tplSearchTimer: number | undefined;

  const escapeHtml = (text: string) => String($("<div>").text(text).html());

  // Apply, never append: picking a second template swaps rather than stacks. There is deliberately
  // no insert-at-cursor path here.
  function applyToComposer(html: string) {
    // The composer is a plain textarea, so markup has to be unwrapped rather than assigned: a
    // template or draft dropped in as HTML would show the user its tags.
    $composeEditor().val(htmlToText(html));
    // Drives the visibility of Discard/Schedule off whether the box is blank — without this, a
    // template lands in a full editor with Discard still hidden.
    updateManualActions();
    $composeEditor().trigger("focus");
  }

  // body_html is escaped-then-<br>'d server-side. The fallback repeats that order exactly so the two
  // paths cannot diverge in their escaping.
  const templateHtml = (row: any) =>
    row.body_html || escapeHtml(String(row.body || "")).replace(/\r\n|\r|\n/g, "<br>");

  function renderTemplates(rows: any[]) {
    const $list = $tpl().find(".inbox-tpl-list").empty();

    if (!rows.length) {
      $list.append($("<p>").addClass("inbox-tpl-empty").text("No templates match."));
      return;
    }

    rows.forEach((row) => {
      $list.append(
        $("<button>").attr("type", "button").addClass("inbox-tpl-item").data("html", templateHtml(row))
          .append($("<span>").addClass("inbox-tpl-item-name").text(row.name))
          .append($("<span>").addClass("inbox-tpl-item-prev").text(row.preview))
      );
    });
  }

  function fetchTemplates() {
    const $wrap = $tpl();
    if (!$wrap.length) return;

    $.ajax({
      url: String($wrap.data("url")),
      data: {email_chain_id: $wrap.data("chain-id"), category: tplCategory(), q: tplQuery()},
      success: (data) => renderTemplates(data.templates || []),
      error: () => renderTemplates([])
    });
  }

  function closeTemplatePopover(): boolean {
    if (!tplPopOpen()) return false;

    $tplPop().removeClass("open").attr("aria-hidden", "true");
    $tpl().find(".inbox-tpl-toggle").attr("aria-expanded", "false");
    return true;
  }

  // HTML -> plain text. Tags become newlines BEFORE .text() strips them, or every line collapses
  // onto one. A closing block tag is a paragraph break (\n\n); a <br> is a line break (\n).
  //
  // Used two ways: "Save this reply" turns the composer into a template body, and the AI draft is
  // unwrapped for the maybe-later modal's plain textareas. Lossy by design — bold, links and lists
  // do not survive.
  const htmlToText = (html: string) =>
    String($("<div>").html(
      String(html || "")
        .replace(/<br\s*\/?>/gi, "\n")
        .replace(/<\/(p|div|li|h[1-6])>/gi, "\n\n")
    ).text())
      .replace(/\n{3,}/g, "\n\n")
      .trim();

  const composerAsText = () => htmlToText(composeBody());

  const openManager = (detail?: object) =>
    window.dispatchEvent(new CustomEvent("reply-templates:open", detail ? {detail} : undefined));

  $drawer.off("click.inboxTplToggle").on("click.inboxTplToggle", ".inbox-tpl-toggle", function(event) {
    event.stopPropagation();
    if (closeTemplatePopover()) return;

    $tplPop().addClass("open").attr("aria-hidden", "false");
    $(this).attr("aria-expanded", "true");
    fetchTemplates();
    $tpl().find(".inbox-tpl-search input").trigger("focus");
  });

  $drawer.off("click.inboxTplPop").on("click.inboxTplPop", ".inbox-tpl-pop", function(event) {
    event.stopPropagation();
  });

  $drawer.off("input.inboxTplSearch").on("input.inboxTplSearch", ".inbox-tpl-search input", function() {
    // Every keystroke is otherwise a round trip into an ILIKE.
    window.clearTimeout(tplSearchTimer);
    tplSearchTimer = window.setTimeout(fetchTemplates, 200);
  });

  $drawer.off("click.inboxTplChip").on("click.inboxTplChip", ".inbox-tpl-chip", function() {
    $tpl().find(".inbox-tpl-chip").removeClass("on");
    $(this).addClass("on");
    fetchTemplates();
  });

  $drawer.off("click.inboxTplItem").on("click.inboxTplItem", ".inbox-tpl-item", function() {
    applyToComposer(String($(this).data("html") || ""));
    // The box is no longer the AI's words, so the violet border and pill come off with it.
    setAiDraft(false);
    closeTemplatePopover();
  });

  $drawer.off("click.inboxTplManage").on("click.inboxTplManage", ".inbox-tpl-manage", function() {
    closeTemplatePopover();
    openManager();
  });

  $drawer.off("click.inboxTplSave").on("click.inboxTplSave", ".inbox-tpl-save-current", function() {
    const body = composerAsText();
    if (!body) return alert("Write a reply first, then save it as a template.");

    closeTemplatePopover();
    // `fresh` forces a create. Without it this would overwrite whatever template happened to be
    // selected in the manager with the current draft.
    openManager({name: "", category: "custom", body, fresh: true});
  });

  $(document).off("click.inboxTplClose").on("click.inboxTplClose", function(event) {
    if ($(event.target).closest(".inbox-tpl").length) return;
    closeTemplatePopover();
  });

  // A template that was just saved must be in the list, whether the popover is open or not.
  //
  // It cannot be gated on the popover being open: both footer actions close it before the manager
  // opens, so that gate would never pass. And the filters have to be cleared first — a category chip
  // or a search term left over from before the manager opened would hide the very template that was
  // just created.
  function resetTemplateFilters() {
    const $wrap = $tpl();
    if (!$wrap.length) return;

    window.clearTimeout(tplSearchTimer);
    $wrap.find(".inbox-tpl-search input").val("");
    $wrap.find(".inbox-tpl-chip").removeClass("on");
    $wrap.find('.inbox-tpl-chip[data-category=""]').addClass("on");
  }

  $(window).off("reply-templates:changed.inboxTpl").on("reply-templates:changed.inboxTpl", function() {
    if (!$tpl().length) return;

    resetTemplateFilters();
    fetchTemplates();
  });

  $drawer.off("click.inboxHide").on("click.inboxHide", ".inbox-hide-response", function() {
    const showing = $(this).hasClass("inbox-show-response");
    if (!window.confirm(showing ? "Show this reply in the inbox again?" : "Hide this reply from the inbox?")) return;

    const $button = $(this).prop("disabled", true);
    post(String($button.data("url")), {}, () => window.location.reload(), () => $button.prop("disabled", false));
  });

  const $compose = () => $drawer.find(".inbox-compose");

  function setDrafting(on: boolean, label?: string) {
    const $wrap = $compose();
    $wrap.toggleClass("drafting", on);
    $wrap.find(".inbox-compose-drafting").prop("hidden", !on);
    if (label) $wrap.find(".inbox-drafting-label").text(label);
  }

  function setAiDraft(on: boolean) {
    $compose().toggleClass("is-ai-draft", on).find(".inbox-ai-pill").prop("hidden", !on);
  }

  $drawer.off("click.inboxDraft").on("click.inboxDraft", ".inbox-ai-draft", function() {
    // Don't touch the label — it holds an inline SVG that .text() would destroy.
    const $button = $(this).prop("disabled", true);
    const $body = $drawer.find(".inbox-drawer-body");
    const sentiment = String($drawer.find(".inbox-sentiment-picker .active").data("status") || "");
    const maybeLater = sentiment === "not_right_now";

    setAiDraft(false);
    setDrafting(true, maybeLater ? "Drafting a reply and a timed follow-up\u2026" : "Drafting a reply\u2026");

    post(`/email_chains/${$body.data("chain-id")}/generate_inbox_draft`,
      {email_response_id: $body.data("response-id"), sentiment},
      (draft) => {
        if (maybeLater) {
          // "Maybe later" is a two-part decision, so it gets the guided modal rather than the box.
          window.dispatchEvent(new CustomEvent("ai-draft:maybe-later", {detail: {
            chainId: String($body.data("chain-id")),
            candidate: $drawer.find(".inbox-person-name strong").first().text().trim(),
            subject: String($drawer.find(".inbox-drawer-footer").data("subject") || ""),
            reply: htmlToText(draft.body),
            followUp: draft.follow_up
              ? {body: htmlToText(draft.follow_up.body), scheduledAt: draft.follow_up.scheduled_at}
              : null
          }}));
          return;
        }

        applyToComposer(String(draft.body || ""));
        setAiDraft(true);
      },
      () => {
        setDrafting(false);
        $button.prop("disabled", false);
      });
  });
}

export function initFullThreadEmailResponses() {
  function changeStatus(event: any) {
    var elem = $(this);
    var links = elem.siblings("a.set-status").addBack();
    var url = elem.attr("href");
    event.preventDefault();

    links
      .children(".status-btn")
      .removeClass("active")
      .removeClass("ai-thinks");

      $.post((url as string), function (data) {

        links
          .children(".status-btn.".concat(data["to"]))
          .addClass("active");
        reflectRowStatus(elem, String(data["to"]));
      });
  }

  $(
    "full-thread .email-response a.set-status, .set-status-buttons a.set-status"
  ).off("click.changeStatus");

  $(
    "full-thread .email-response a.set-status, .set-status-buttons a.set-status"
  ).on("click.changeStatus", changeStatus);

  $("button.toggle-full-thread").off('click').on('click', function(e) {
    var botsProspectId = $(this).data("bots-prospect-id");
    var $fullThreadEle = $('.full-thread-' + botsProspectId)

    if($fullThreadEle.is(":visible")) {
      $fullThreadEle.hide()
      $(this).text('Show full thread')
    } else {
      $fullThreadEle.show()
      $(this).text('Collapse full thread')
    }
  });
}
